import React from 'react';

const Hawaii = () => (
  <svg
    width="62"
    height="43"
    viewBox="0 0 62 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.5">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.04098 0.570485C6.34371 2.40817 5.44257 3.04887 5.02016 4.1543C3.02781 4.274 2.36607 3.05592 0.922852 2.61938C1.39454 0.830981 4.14719 -0.689845 6.04098 0.570485Z"
        fill="#FC374D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.4511 7.73818C23.5708 10.0053 25.9715 9.99827 26.0137 12.3429C24.9647 13.2582 23.6905 10.8643 22.9442 10.808C22.6978 10.7869 22.2121 11.7233 22.4303 11.8289C21.2968 11.2586 20.4872 10.7165 19.8677 8.75911C21.9093 9.27309 21.4095 7.23828 23.4511 7.73818Z"
        fill="#FC374D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.8545 17.4686C43.7973 17.2574 46.0078 17.7784 46.4866 20.0314C45.2827 20.5384 43.9733 20.9326 42.3892 21.0523C41.9739 20.1018 41.7275 18.9823 40.8545 18.4965"
        fill="#FC374D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.1077 17.9826C40.6994 17.9756 40.5093 17.7573 40.2559 17.5531L41.1077 17.9826Z"
        fill="#FC374D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.7085 17.9827C34.9197 16.7083 36.6938 17.9545 36.2432 19.0036C35.5744 18.8205 35.4407 18.1024 34.7085 17.9827Z"
        fill="#FC374D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.556 26.1711C51.0485 26.9104 52.703 27.5159 54.1673 28.22C56.2864 29.2339 58.1027 29.8042 59.2855 31.8039C59.6445 32.4023 59.377 32.3883 59.7994 32.8248C60.2148 33.2613 60.4119 33.9302 60.8202 34.3597C61.0103 34.5568 61.8199 35.3243 61.8411 36.4086C60.3556 36.0565 60.257 38.0139 58.7716 38.4575C58.0676 38.6687 56.8426 38.1055 56.2089 38.4575C54.3996 39.4643 53.0972 40.6191 52.6255 42.5553C51.126 42.6891 51.0555 41.3935 49.556 41.5273C49.6968 38.1406 49.3377 35.2609 48.0212 33.3388C48.4648 31.5645 49.6194 30.5013 50.5839 29.241C50.2882 28.1707 49.3096 27.7835 49.556 26.1711Z"
        fill="#FC374D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.9409 14.1382C34.4548 14.3213 34.9688 14.5396 35.4756 14.6522L33.9409 14.1382Z"
        fill="#FC374D"
      />
    </g>
  </svg>
);
export default Hawaii;
